/*
  Free tea sample: keeps the gift line in step with the cart.
  - eligible subtotal (everything except the gift) >= goal  -> add 1 gift
  - eligible subtotal < goal                                -> remove the gift
  If the gift ever shows a price (it should be $0), it is taken out again so nobody is charged for it.
  Removal goes through cart/update.js keyed by variant: cart/change.js by line key loses a unit of another
  product when Shopify has split that product's line (seen 2026-10-22 with a Buy X Get Y discount).
*/
(function () {
  if (window.AMTFreeSample) return;
  var cfg = window.AMTFreeSampleConfig || {};
  var GIFT_VARIANT = Number(cfg.variantId);
  var GOAL = Number(cfg.goal) || 5000;
  if (!GIFT_VARIANT) return;
  window.AMTFreeSample = { version: 1 };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var pending = false;

  function getJSON(path, options) {
    var opts = options || {};
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(root + path, opts).then(function (r) { return r.json(); });
  }

  function postJSON(path, body) {
    return getJSON(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function setGiftQuantity(quantity) {
    var updates = {};
    updates[GIFT_VARIANT] = quantity;
    return postJSON('cart/update.js', { updates: updates });
  }

  function findGift(cart) {
    return cart.items.find(function (item) { return item.variant_id === GIFT_VARIANT; });
  }

  function eligibleTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return item.variant_id === GIFT_VARIANT ? sum : sum + item.final_line_price;
    }, 0);
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    var changed = false;

    getJSON('cart.js')
      .then(function (cart) {
        var gift = findGift(cart);
        var wantGift = cart.item_count > 0 && eligibleTotal(cart) >= GOAL;

        if (wantGift && !gift) {
          changed = true;
          return postJSON('cart/add.js', { id: GIFT_VARIANT, quantity: 1 })
            .then(function () { return getJSON('cart.js'); })
            .then(function (after) {
              var added = findGift(after);
              // The discount should make it free. If it did not, remove it rather than charge for it.
              if (added && added.final_line_price > 0) {
                console.warn('free-sample-gift: sample is not free, removing it');
                return setGiftQuantity(0);
              }
            });
        }
        if (gift && !wantGift) {
          changed = true;
          return setGiftQuantity(0);
        }
        if (gift && gift.quantity !== 1) {
          changed = true;
          return setGiftQuantity(1);
        }
      })
      .then(function () { if (changed) return refresh(); })
      .catch(function (err) { console.error('free-sample-gift', err); })
      .finally(function () {
        busy = false;
        if (pending) { pending = false; sync(); }
      });
  }

  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function nodeOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  // Re-render the parts of the page that show the cart, the same way the theme does after a quantity change.
  function refresh() {
    var cartItems = document.getElementById('main-cart-items');
    var cartFooter = document.getElementById('main-cart-footer');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (cartItems && cartItems.dataset.id) sections.push(cartItems.dataset.id);
    if (cartFooter && cartFooter.dataset.id) sections.push(cartFooter.dataset.id);

    return Promise.all([
      getJSON('?sections=' + sections.join(',')),
      getJSON('cart.js')
    ]).then(function (results) {
      var html = results[0];
      var cart = results[1];
      var empty = cart.item_count === 0;

      var drawer = document.querySelector('cart-drawer');
      if (drawer && html['cart-drawer']) {
        drawer.classList.toggle('is-empty', empty);
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.toggle('is-empty', empty);
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
          var target = drawer.querySelector(selector);
          var source = nodeOf(html['cart-drawer'], selector);
          if (target && source) target.replaceWith(source);
        });
      }

      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && html['cart-icon-bubble']) {
        var bubbleHtml = innerOf(html['cart-icon-bubble'], '.shopify-section');
        if (bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
      }

      if (cartItems && html[cartItems.dataset.id]) {
        cartItems.classList.toggle('is-empty', empty);
        var itemsTarget = cartItems.querySelector('.js-contents');
        var itemsHtml = innerOf(html[cartItems.dataset.id], '.js-contents');
        if (itemsTarget && itemsHtml !== null) itemsTarget.innerHTML = itemsHtml;
      }

      if (cartFooter && html[cartFooter.dataset.id]) {
        cartFooter.classList.toggle('is-empty', empty);
        var footerTarget = cartFooter.querySelector('.js-contents');
        var footerHtml = innerOf(html[cartFooter.dataset.id], '.js-contents');
        if (footerTarget && footerHtml !== null) footerTarget.innerHTML = footerHtml;
      }
    });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); });
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
